var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { position: "relative" },
      style: { minHeight: _vm.height + "px" },
    },
    [
      _c("a-spin", {
        staticClass: "chart-loading",
        attrs: { tip: "加载中...", spinning: _vm.loadingChart },
      }),
      !_vm.loadingChart && _vm.data.length > 0
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "title-container" },
                [
                  _c(
                    "h4",
                    {
                      class: _vm.titleClass,
                      style: { margin: "0 0 20px 20px", ..._vm.titleStyle },
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _vm.showReturnBtn
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleReturn },
                        },
                        [_vm._v("返回上级")]
                      )
                    : _vm._e(),
                  _vm._t("titleExtra"),
                ],
                2
              ),
              _vm.isShowGuide
                ? _c(
                    "v-chart",
                    {
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: {
                        "force-fit": true,
                        height: _vm.height,
                        data: _vm.data,
                        scale: _vm.scale,
                      },
                    },
                    [
                      _c("v-tooltip"),
                      _c("v-axis"),
                      _c("v-legend"),
                      _c("v-smooth-line", {
                        attrs: { position: "type*y", color: "x" },
                      }),
                      _c("v-point", {
                        attrs: {
                          position: "type*y",
                          color: "x",
                          size: 4,
                          "v-style": _vm.style,
                          shape: "circle",
                          onClick: _vm.pointChartClick,
                        },
                      }),
                      _vm._l(_vm.guideEventList, function (item, index) {
                        return _c(
                          "v-guide",
                          _vm._b(
                            {
                              key: index,
                              attrs: {
                                type: "image",
                                src: _vm.guideEventImg,
                                width: 20,
                                height: 20,
                                offsetX: -12,
                                offsetY: -30,
                                top: true,
                                zIndex: 9999,
                                start: item.position,
                                end: item.position,
                              },
                            },
                            "v-guide",
                            _vm.guideConfig,
                            false
                          )
                        )
                      }),
                      _vm._l(_vm.guideWarntList, function (item, index) {
                        return _c(
                          "v-guide",
                          _vm._b(
                            {
                              key: index,
                              attrs: {
                                type: "image",
                                src: _vm.guideWarnImg,
                                width: 20,
                                height: 20,
                                offsetX: -13,
                                offsetY: -30,
                                top: true,
                                zIndex: 9999,
                                start: item.position,
                                end: item.position,
                              },
                            },
                            "v-guide",
                            _vm.guideConfig,
                            false
                          )
                        )
                      }),
                      _vm._l(_vm.guideMoreEventList, function (item, index) {
                        return _c(
                          "v-guide",
                          _vm._b(
                            {
                              key: index,
                              attrs: {
                                type: "image",
                                src: _vm.guideMoreEventImg,
                                width: 20,
                                height: 20,
                                offsetX: -13,
                                offsetY: -30,
                                top: true,
                                zIndex: 9999,
                                start: item.position,
                                end: item.position,
                              },
                            },
                            "v-guide",
                            _vm.guideConfig,
                            false
                          )
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c("div", [
                _vm.tipStatus
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "tip-modal animate__animated animate__bounceIn",
                        style: _vm.tipStyle,
                      },
                      [
                        _vm._t(
                          "guideTipModal",
                          function () {
                            return _vm._l(
                              _vm.guideTipList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      width: "100%",
                                      "margin-bottom": "10px",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "tip-head" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tip-title",
                                          class:
                                            item.type == "warn"
                                              ? "warn-title"
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.title) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _c("span", { staticClass: "tip-time" }, [
                                        _vm._v(_vm._s(item.time)),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "tip-desc" }, [
                                      _vm._v(_vm._s(item.desc)),
                                    ]),
                                  ]
                                )
                              }
                            )
                          },
                          { record: _vm.guideTipList }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.tipStatus
                  ? _c(
                      "div",
                      {
                        staticClass: "tip-mask",
                        on: { click: () => (_vm.tipStatus = false) },
                      },
                      [_vm._v("关闭")]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : !_vm.loadingChart && _vm.data.length == 0 && _vm.isShowNoDataIcon
        ? _c(
            "div",
            {
              staticClass: "chart-loading",
              staticStyle: {
                "font-size": "16px",
                "text-align": "center",
                color: "#ccc",
              },
            },
            [
              _c("div", [
                _c("img", {
                  staticStyle: { width: "100px", height: "80px" },
                  attrs: { src: require("@assets/nodata.png"), alt: "" },
                }),
                _c("div", [_vm._v("暂无数据")]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }